import { lazy } from "react";
import { CreateBooking } from "components/bookings/createBooking";

const ServiceableArea = lazy(() => import("components/serviceableArea"));
const CustomerDetail = lazy(() => import("components/customer/customerDetail"));
const Customers = lazy(() => import("components/customer"));
const MyCalendar = lazy(() => import("components/calendar"));
const Home = lazy(() => import("components/home"));
const Bookings = lazy(() => import("components/bookings"));
const Staff = lazy(() => import("components/staff"));
const Profile = lazy(() => import("components/profile"));
const AddStaff = lazy(() => import("components/staff/addStaff"));
const AboutUs = lazy(() => import("components/profile/aboutUs/AboutUs"));
const Help = lazy(() => import("components/profile/help/Help"));
const FAQ = lazy(() => import("components/profile/help/FAQ/FAQ"));
const Earning = lazy(() => import("components/profile/earning/Earning"));
const MyService = lazy(() => import("components/profile/myService/MyService"));
const Payback = lazy(() => import("components/profile/payback/Payback"));

const ServiceDetail = lazy(() =>
  import("components/profile/myService/serviceDetail/ServiceDetail")
);
const BookingDetails = lazy(() =>
  import("components/bookings/bookingDetails/BookingDetails")
);
const ManageAvailability = lazy(() =>
  import("components/profile/manageAvailability/ManageAvailability")
);
const StaffAvailability = lazy(() =>
  import("components/staff/staffAvailability/StaffAvailability")
);

const ScreenRoutes = [
  { path: "/home", name: "Home", element: <Home /> },
  { path: "/bookings", name: "Booking", element: <Bookings /> },
  { path: "/staff", name: "Staff", element: <Staff /> },
  { path: "/profile", name: "Profile", element: <Profile /> },
  { path: "/staff/addstaff", name: "AddStaff", element: <AddStaff /> },
  { path: "/staff/update", name: "staffUpdate", element: <AddStaff /> },
  { path: "/profile/about-us", name: "aboutUs", element: <AboutUs /> },
  { path: "/profile/help", name: "help", element: <Help /> },
  { path: "/profile/help/FAQ", name: "help", element: <FAQ /> },
  { path: "/earning", name: "Earning", element: <Earning /> },
  {
    path: "/bookings/create-booking",
    name: "CreateBooking",
    element: <CreateBooking />,
  },
  {
    path: "/profile/availability",
    name: "help",
    element: <ManageAvailability />,
  },
  {
    path: "/bookings/detail/:id",
    name: "bookingDetail",
    element: <BookingDetails />,
  },
  {
    path: "/service/",
    name: "service",
    element: <MyService />,
  },
  {
    path: "/service/details/:id",
    name: "serviceDetail",
    element: <ServiceDetail />,
  },
  {
    path: "/earning/payback",
    name: "serviceDetail",
    element: <Payback />,
  },
  {
    path: "/calendar",
    name: "calendar",
    element: <MyCalendar />,
  },
  {
    path: "/staff/availability/:id",
    name: "calendar",
    element: <StaffAvailability />,
  },
  {
    path: "/customer",
    name: "customer",
    element: <Customers />,
  },
  {
    path: "/customer/detail/:id",
    name: "customer-detail",
    element: <CustomerDetail />,
  },
  {
    path: "/profile/serviceable-area",
    name: "serviceable-area",
    element: <ServiceableArea />,
  },
];

export default ScreenRoutes;
